<template>
  <div>
    <datatable
      title="Admin Education Institutions"
      @delete="deleteEducationInstitution"
      @create="createEducationInstitution"
      @edit_click="editClick"
      :fields="fields"
      :response="data"
    ></datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'admin-education-institutions',
  data () {
    return {
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'institution_name',
          value: 'name'
        },
        {
          name: 'institution_type',
          value: 'institution_type'
        }
      ],
      data: [],
      operations: []
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils.getAllEducationInstitutions().then(response => {
        this.data = response
      })
    },
    deleteEducationInstitution (delete_data) {
      this.create({
        designator: 'delete-prompt',
        component_name: 'DeletePrompt',
        modal_title: 'Delete ' + delete_data.name,
        item_name: delete_data.name,
        method: 'deleteEducationInstitution',
        method_params: { id: delete_data.id }
      })
    },
    createEducationInstitution () {
      this.create({ designator: 'admin-education-institutions-form-modal', component_name: 'AdminEducationInstitutionsForm', is_create: true, modal_title: 'Create new Education Institution' })
    },
    editClick (data) {
      this.create({ designator: 'admin-education-institutions-form-modal', component_name: 'AdminEducationInstitutionsForm', data, modal_title: data.name })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
